import React from 'react';
import { Card, Col, Row } from "react-bootstrap";
import { FaThumbsUp, FaCommentDots } from "react-icons/fa";
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';

import './blogCard.module.css';
import { Link } from 'react-router-dom';

const BlogStickyCard = ({banner, title, subTitle, url, createdAt}, ...props) => {

    const urlForFb = window.location.protocol + "//" + window.location.host + url;

    return (
        <Card styleName="blog-card featured">
            <Row>
                <Col xs={12} md={6}>
                    <Link to={url}>
                        <Card.Img variant="top" src={!!banner && banner } styleName="cover-img" />
                    </Link>
                </Col>
                <Col xs={12} md={6}>
                    <Card.Body>
                        <Link to={url} className="text-decor-none">
                            <Card.Title styleName="blog-card-title">
                                { !!title && title }
                            </Card.Title>
                        </Link>
                        <Card.Text styleName="blog-card-subtitle">
                            { !!subTitle && subTitle }
                        </Card.Text>
                    </Card.Body>
                    <div className='p-3'>
                        <div className="d-flex flex-column">
                            <LinkContainer to={url}>
                                <Card.Link className="text-success text-underline mb-5" styleName="blog-read-more">আরো পড়ুন</Card.Link>
                            </LinkContainer>
                            <div className="d-inline" styleName="blog-card-statistics">
                                <span className='text-secondary'>
                                    {moment(Date.parse(createdAt)).format('MMM DD, YYYY')}
                                </span>
                            </div>
                        </div>
                        {/* <Card.Link href="#">Another Link</Card.Link> */}
                    </div>
                </Col>
            </Row>
        </Card>
    )
}

export default BlogStickyCard;